import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BoldIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Bold",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M8.74 30h8.82A8.284 8.284 0 0 0 23 15.47a8.3 8.3 0 0 0 1.82-5.19c0-4.57-3.71-8.28-8.28-8.28H8.75a2.59 2.59 0 0 0-2.59 2.59v22.82A2.59 2.59 0 0 0 8.75 30Zm8.77-5.18h-6.18v-6.23h6.37c1.72 0 3.11 1.39 3.11 3.11s-1.39 3.11-3.11 3.11h-.2ZM11.33 7.18h5.37c1.72 0 3.11 1.39 3.11 3.11s-1.39 3.11-3.11 3.11h-5.38V7.18Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M17.43 29.29H8c-.63 0-1.14-.51-1.14-1.14V3c0-.63.51-1.14 1.14-1.14h9.43c3.52 0 6.38 2.86 6.38 6.38 0 2.05-.97 3.88-2.48 5.05a8.48 8.48 0 0 1 4.58 7.52c0 4.67-3.8 8.48-8.48 8.48M9.14 27h8.29c3.41 0 6.19-2.78 6.19-6.19s-2.78-6.19-6.19-6.19H9.14zm0-14.67h8.29a4.095 4.095 0 0 0 0-8.19H9.14z"
      })
    })
  }));
};
BoldIcon.displayName = 'BoldIcon';